// 原始baseUrl：http://192.168.124.33:9230
// const baseURL = okapi.url+'/api'
class Ajax {
  get(url) {
    return new Promise((resolve, reject) => {
      url = '/api' + url;
      fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          // 'X-Okapi-Tenant': config.okapi.tenant,
          // 'X-Okapi-Token': token
        },
      })
        .then((res) => res.json())
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  // post方式
  post(url, data) {
    url = '/api' + url;
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // 'X-Okapi-Tenant': config.okapi.tenant,
          // 'X-Okapi-Token': token,
          // 'type':'text'
        },
        body: JSON.stringify(data),
      })
        .then(async (response) => {
          if (response.ok) {
            // 请求成功
            return await response.json();
          } else {
            return Promise.reject({
              status: response.status,
              statusText: response.statusText,
              data: await response.json(),
            });
          }
        })
        .then((data) => resolve(data))
        .catch((err) => {
          reject(err);
        });
    });
  }

  //put 修改
  put(url, data) {
    url = '/api' + url;
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          // 'X-Okapi-Tenant': config.okapi.tenant,
          // 'X-Okapi-Token': token
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  //delete
  delete(url, data) {
    url = '/api' + url;
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'DELETE',
        headers: {
          // 'Content-Type': 'application/json',
          // 'X-Okapi-Tenant': config.okapi.tenant,
          // 'X-Okapi-Token': token
        },
        // body: JSON.stringify(data)
      })
        // .then(res => res.json())
        .then((data) => resolve('数据删除成功!'))
        .catch((err) => reject(err));
    });
  }
}
export default new Ajax(); //ES6导出
